import { render, staticRenderFns } from "./IdDashboard.vue?vue&type=template&id=612cf518&scoped=true"
import script from "./IdDashboard.vue?vue&type=script&lang=js"
export * from "./IdDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cf518",
  null
  
)

export default component.exports